import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Section } from '../Section/Section';
import { Carousel } from './Carousel';
import { useTracking } from '../../tracking/useTracking';
export function CarouselSection(props) {
    const { emitUserInteractionEvent } = useTracking();
    const handleActiveSlideChange = (currentSlide, previousSlide) => {
        emitUserInteractionEvent({
            event_action: 'click',
            interaction_name: 'carousel_button_click',
            option_selected: currentSlide > previousSlide ? 'next' : 'previous',
        });
    };
    return (_jsx(Section, Object.assign({ contentWidth: "overflow", heading: props.heading, subheading: props.subheading }, { children: _jsx(Carousel, Object.assign({ onActiveSlideChange: handleActiveSlideChange }, { children: props.children })) })));
}
//# sourceMappingURL=CarouselSection.js.map